import { ColumnDef } from '@tanstack/react-table';
import {IconButton} from "@lib/Buttons";
import classNames from 'classnames';
import { WorkspaceInvite } from '@/models/workspace';
import { InviteTableRowType } from '../types';
import {TrashIcon} from "@lib/Icons";

type InviteActionsColumnProps = {
  canDelete: boolean;
  onDelete?: (invite: WorkspaceInvite) => void;
};

export const getInviteActionsColumn = ({ canDelete, onDelete }: InviteActionsColumnProps): ColumnDef<InviteTableRowType> => ({
  id: 'actions',
  header: '',
  enableSorting: false,
  size: 50,
  cell: ({ row }) => (
    <div className='flex justify-end'>
      {canDelete && onDelete && (
        <IconButton 
          leadingIcon={<TrashIcon className='size-4' />} 
          onClick={() => onDelete?.(row.original)} 
          intent='link-grey'
          size='sm'
        /> 
      )}
    </div>
  ),
});